import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { GoogleMapsProvider } from './components/maps/GoogleMapsProvider.tsx'
import { ToastProvider } from './components/ui/ToastProvider.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ToastProvider>
      <GoogleMapsProvider>
        <App />
      </GoogleMapsProvider>
    </ToastProvider>
  </React.StrictMode>,
)
